import React from 'react';

const StoryPreviewOverlay = () => {
  const st0 = { fill: '#0F1C14' };
  const st1 = { opacity: 0.35, fill: 'none', stroke: '#0F1C14', strokeWidth: '1.0688', enableBackground: 'new' };
  const st2 = { opacity: 0.4, enableBackground: 'new' };
  const st4 = { fill: '#19F578' };
  const st5 = { fill: '#DBDDDC' };

  return (
    <div className="preview-overlay" role="info">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 368 655">
        <g>
          <path
            style={st0}
            d="M36.1,21.7c-2.7,0-4.5,1.8-4.8,4.2c0,2.3,1.7,4,4,4c1.7,0,2.8-0.8,3.2-1.8h0.2c0,0.1,0,0.2,0,0.3
		c-0.1,2.3-0.9,4.2-2.8,4.2c-1,0-1.8-0.6-2.1-1.4v-0.1h-2.1v0.1c0.4,1.9,2.1,3.2,4.3,3.2c3.1,0,4.9-2.4,4.9-6.5
		C40.9,23.5,38.7,21.7,36.1,21.7z M36.1,28.4c-1.4,0-2.4-1.1-2.4-2.5c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.5
		S37.5,28.4,36.1,28.4z"
          />
          <path
            style={st0}
            d="M44.3,26.3c-0.8,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3c0.8,0,1.3,0.6,1.3,1.3
		C45.7,25.7,45.1,26.3,44.3,26.3z"
          />
          <path
            style={st0}
            d="M44.3,32.5c-0.8,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3c0.8,0,1.3,0.6,1.3,1.3C45.7,32,45.1,32.5,44.3,32.5z
		"
          />
          <path
            style={st0}
            d="M55.7,30.1v-8h-3.1c-1.6,2.5-3.3,5.3-4.9,8v1.8h5.9v2.3h2.1v-2.3h1.6v-1.8H55.7z M53.7,30.1h-3.9V30
		c1.2-2.1,2.6-4.3,3.8-6.2h0.1V30.1z"
          />
          <polygon
            style={st0}
            points="61.9,34.2 61.9,24.2 61.8,24.2 58.8,26.3 58.8,24.3 62,22.1 64.2,22.1 64.2,34.2 	"
          />
          <path
            style={st1}
            d="M321.2,25.3c0-1.9,1.6-3.5,3.5-3.5h17.2c1.9,0,3.5,1.6,3.5,3.5v5.1c0,1.9-1.6,3.5-3.5,3.5h-17.2
		c-1.9,0-3.5-1.6-3.5-3.5V25.3z"
          />
          <path style={st2} d="M347,26.3v4.3c0.9-0.4,1.4-1.2,1.4-2.1C348.4,27.5,347.8,26.6,347,26.3z" />
          <path d="M322.7,25.3c0-1.1,0.9-2,2-2h17.2c1.1,0,2,0.9,2,2v5.1c0,1.1-0.9,2-2,2h-17.2c-1.1,0-2-0.9-2-2V25.3z" />
          <path
            d="M304.9,24.9c2.5,0,4.9,1,6.7,2.7c0.1,0.1,0.4,0.1,0.5,0l1.3-1.3c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
		c-4.8-4.6-12.3-4.6-17,0c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3l1.3,1.3c0.1,0.1,0.4,0.1,0.5,0
		C300,25.8,302.4,24.9,304.9,24.9z"
          />
          <path
            d="M305,29c1.4,0,2.7,0.5,3.7,1.5c0.1,0.1,0.4,0.1,0.5,0l1.3-1.3c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
		c-3.1-2.9-7.9-2.9-11,0c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3l1.3,1.3c0.1,0.1,0.4,0.1,0.5,0C302.3,29.5,303.6,29,305,29z"
          />
          <path
            d="M307.6,31.7c0,0.1,0,0.2-0.1,0.3l-2.3,2.3c-0.1,0.1-0.2,0.1-0.2,0.1s-0.2,0-0.2-0.1l-2.3-2.3
		c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3c1.4-1.2,3.5-1.2,5,0C307.6,31.5,307.6,31.6,307.6,31.7z"
          />
          <path d="M280.1,25.3c0-0.6,0.5-1,1-1h1c0.6,0,1,0.5,1,1v8.1c0,0.6-0.5,1-1,1h-1c-0.6,0-1-0.5-1-1V25.3z" />
          <path d="M285.2,23.2c0-0.6,0.5-1,1-1h1c0.6,0,1,0.5,1,1v10.1c0,0.6-0.5,1-1,1h-1c-0.6,0-1-0.5-1-1V23.2z" />
          <path d="M275.1,28.8c0-0.6,0.5-1,1-1h1c0.6,0,1,0.5,1,1v4.6c0,0.6-0.5,1-1,1h-1c-0.6,0-1-0.5-1-1V28.8z" />
          <path d="M270,31.4c0-0.6,0.5-1,1-1h1c0.6,0,1,0.5,1,1v2c0,0.6-0.5,1-1,1h-1c-0.6,0-1-0.5-1-1V31.4z" />
          <path
            style={st0}
            d="M339.5,63.7l-5.1,5.1c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2s-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5l5.1-5.1
		l-5.1-5.1c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5s0.3-0.2,0.5-0.2s0.4,0.1,0.5,0.2l5.1,5.1l5.1-5.1c0.1-0.1,0.3-0.2,0.5-0.2
		s0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5l-5.1,5.1l5.1,5.1c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5
		s-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2L339.5,63.7z"
          />
          <path
            style={st4}
            d="M14,78.6h59c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5H14c-0.8,0-1.5-0.7-1.5-1.5l0,0
		C12.5,79.3,13.2,78.6,14,78.6z"
          />
          <path
            style={st5}
            d="M84.2,78.6h59.2c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5H84.2c-0.8,0-1.5-0.7-1.5-1.5l0,0
		C82.7,79.3,83.4,78.6,84.2,78.6z"
          />
          <path
            style={st4}
            d="M84.2,78.6h28c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5h-28c-0.8,0-1.5-0.7-1.5-1.5l0,0
		C82.7,79.3,83.4,78.6,84.2,78.6z"
          />
          <path
            style={st5}
            d="M154.4,78.6h59.2c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5h-59.2c-0.8,0-1.5-0.7-1.5-1.5l0,0
		C152.9,79.3,153.6,78.6,154.4,78.6z"
          />
          <path
            style={st5}
            d="M224.6,78.6h59.2c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5h-59.2c-0.8,0-1.5-0.7-1.5-1.5l0,0
		C223.1,79.3,223.8,78.6,224.6,78.6z"
          />
          <path
            style={st5}
            d="M294.8,78.6H354c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5h-59.2c-0.8,0-1.5-0.7-1.5-1.5l0,0
		C293.3,79.3,294,78.6,294.8,78.6z"
          />
        </g>
      </svg>
    </div>
  );
};

export default StoryPreviewOverlay;
